// Generated by `yarn tokens:import --aos-ds` from the Figma "Spacing" variables export. Do not edit.
//
// Keys are Figma's own aliases, holding the raw number Figma stores, in
// whatever unit that collection uses. `tailwind-preset.js` turns them into
// the Tailwind scale, so a class name and a Figma token are the same word.

export const spacing = {
    'large-layout/2xl': 24,
    'large-layout/3xl': 32,
    'large-layout/4xl': 36,
    'medium-less-dense/l': 16,
    'medium-less-dense/m': 12,
    'medium-less-dense/xl': 20,
    'small-compact/2xs': 2,
    'small-compact/3xs-seam': 1,
    'small-compact/s': 8,
    'small-compact/xs': 4,
} as const

export type SpacingAlias = keyof typeof spacing
